// searchActions.js — DealCouponz pattern: thunks → searchServices
import * as types from "../types/searchTypes";
import * as searchServices from "../../services/searchServices";

export const fetchSearchSuggestions = (q, limit = 8, signal) =>
  async (dispatch) => {
    dispatch({ type: types.FETCH_SEARCH_SUGGESTIONS_REQUEST });
    try {
      const { stores, coupons } = await searchServices.getSearchSuggestions(
        q,
        limit,
        signal
      );
      if (signal?.aborted) {
        dispatch({ type: types.SEARCH_SUGGESTIONS_CANCELLED });
        return;
      }
      dispatch({
        type: types.FETCH_SEARCH_SUGGESTIONS_SUCCESS,
        payload: { stores, coupons },
      });
    } catch (error) {
      if (signal?.aborted || error?.code === "ERR_CANCELED") {
        dispatch({ type: types.SEARCH_SUGGESTIONS_CANCELLED });
        return;
      }
      dispatch({
        type: types.FETCH_SEARCH_SUGGESTIONS_FAILURE,
        payload: error?.message || "Suggestions failed",
      });
    }
  };

export const clearSearchSuggestions = () => ({
  type: types.CLEAR_SEARCH_SUGGESTIONS,
});

export const fetchTrendingSearchTerms = () => async (dispatch) => {
  dispatch({ type: types.GET_SEARCH_TRENDING_TERMS_REQUEST });
  try {
    const terms = await searchServices.getSearchTrendingTerms();
    dispatch({
      type: types.GET_SEARCH_TRENDING_TERMS_SUCCESS,
      payload: terms,
    });
  } catch (error) {
    dispatch({
      type: types.GET_SEARCH_TRENDING_TERMS_FAILURE,
      payload: error?.message || "Failed to load trending terms",
    });
  }
};
